import { render, staticRenderFns } from "./WorkplaceOverview.vue?vue&type=template&id=55a218b2&"
import script from "./WorkplaceOverview.vue?vue&type=script&lang=js&"
export * from "./WorkplaceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports